import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import useFetch from "../hooks/use-fetch";
import { toast } from "react-toastify";
import { AuthContext } from "./AuthProvider";


export interface ReportData {
  id: string;
  company_name: string;
  cup: string;
  kind: "fesr" | "avvni";
  status: "ready" | "ongoing";
  updated_at: string;
  creator: {
    id: number;
    email: string;
  } | null;
}

type ReportContextType = {
  reports: ReportData[];
  setReports: React.Dispatch<React.SetStateAction<ReportData[]>>;
  fetchReports: () => Promise<void>;
};

type toastType =  {
  kind: string, 
  message: string
}

const initialContext: ReportContextType = {
  reports: [],
  setReports: () => {},
  fetchReports: async () => {},
};

const ReportContext = createContext<ReportContextType>(initialContext);

export const ReportProvider = ({ children }: { children: ReactNode }) => {
  const { isAuth } = useContext(AuthContext)
  const { get } = useFetch();
  const [reports, setReports] = useState<ReportData[]>([]);

  const fetchReports = async () => {
    let toasts: toastType[] = []

    try {
      let data = await get("/reports/");
      let newReports = data.reports;

      setReports((prevReports) => {
        newReports.forEach((rNew: ReportData) => {
          const oldReport = prevReports.find((rOld) => rOld.id === rNew.id);
          if (oldReport && rNew.status !== oldReport.status) {
            if (rNew.status === "ready") {
              toasts.push({'kind': 'success', 'message': `Il report per ${rNew.company_name} è stato generato con successo.`})
            } else {
              toasts.push({'kind': 'error', 'message': `Errore durante la generazione del report per ${rNew.company_name}.`})
            }
          }
        });
        
        

        return newReports;
      });
    } catch (err) {
      toast.error("Errore durante il recupero dei report.");
    }

    toasts.forEach((t) => {
      if (t.kind == 'success'){
        toast.success(t.message)
      } else {
        toast.error(t.message)
      }
    })

  };

  useEffect(() => {
    if (!isAuth) return
    fetchReports();
    const interval = setInterval(fetchReports, 10000);
    return () => clearInterval(interval);
  }, [isAuth]);

  return (
    <ReportContext.Provider value={{ reports, setReports, fetchReports }}>
      {children}
    </ReportContext.Provider>
  );
};

export const useReports = () => {
  const ctx = useContext(ReportContext);
  if (!ctx) {
    throw new Error("useReports must be used within a ReportProvider");
  }
  return ctx;
};